import {createReducer, on} from "@ngrx/store";
import {checkoutEntityAdapter as EntityAdapter, initialState} from "./checkout.state";
import {CheckoutActions as Actions} from "./checkout.actions";

export const checkoutReducer = createReducer(
  initialState,

  on(Actions.loadSingleSuccess, (state, {entity, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.setOne(entity, {
          ...state,
          isLoading: false,
          currentEntity: entity,
          error: undefined,
        });

      return EntityAdapter.setOne(entity, {
        ...state,
        isLoading: false,
        error: undefined,
        currentEntity: entity,
        correlationId,
        history: [...state.history, {correlationId, payload: entity}]
      });
    }
  ),

  on(Actions.loadSingleFailure,(state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),


  on(Actions.load, Actions.loadSingle, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId
  })),

  on(Actions.loadSuccess, (state, {entities, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.setAll(entities, {
          ...state,
          isLoading: false,
          error: undefined,
        });

      return EntityAdapter.setAll(entities, {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entities}]
      });
    }
  ),

  on(Actions.loadFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.create, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.createSuccess, (state, {entity, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.addOne(entity, {
          ...state,
          isLoading: false,
          error: undefined,
        });

      return EntityAdapter.addOne(entity, {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entity}]
      });
    }
  ),

  on(Actions.createFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.createMany, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.createManySuccess, (state, {entities, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.addMany(entities, {
        ...state,
        isLoading: false,
        error: undefined,
      });

    return EntityAdapter.addMany(entities, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: entities}],
    });
  }),

  on(Actions.createManyFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),


  on(Actions.update, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.updateSuccess, (state, {entity, correlationId}) => {
      if (!correlationId)
        return EntityAdapter.updateOne(
          {id: entity.id, changes: entity},
          {
            ...state,
            isLoading: false,
            error: undefined,
          });

      return EntityAdapter.updateOne(
        {id: entity.id, changes: entity},
        {
          ...state,
          isLoading: false,
          error: undefined,
          correlationId,
          history: [...state.history, {correlationId, payload: entity}]
        });
    }
  ),

  on(Actions.updateFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.updateMany, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.updateManySuccess, (state, {entities, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.updateMany(
        entities.map(entity => ({id: entity.id, changes: entity})),
        {
          ...state,
          isLoading: false,
          error: undefined,
        });

    return EntityAdapter.updateMany(
      entities.map(entity => ({id: entity.id, changes: entity})),
      {
        ...state,
        isLoading: false,
        error: undefined,
        correlationId,
        history: [...state.history, {correlationId, payload: entities}],
      });
  }),

  on(Actions.updateManyFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.remove, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.removeSuccess, (state, {entityId, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.removeOne(entityId, {
        ...state,
        isLoading: false,
        error: undefined,
      });

    return EntityAdapter.removeOne(entityId, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      history: [...state.history, {correlationId, payload: entityId}]
    });
  }),

  on(Actions.removeFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.loadPage, (state, {correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.loadPageSuccess, (state, {resultWithPageInfo, correlationId}) => {
    if (!correlationId)
      return EntityAdapter.setAll(resultWithPageInfo.entities, {
        ...state,
        isLoading: false,
        error: undefined,
        currentPage: resultWithPageInfo.pageInfo,
      });

    return EntityAdapter.setAll(resultWithPageInfo.entities, {
      ...state,
      isLoading: false,
      error: undefined,
      correlationId,
      currentPage: resultWithPageInfo.pageInfo,
      history: [...state.history, {correlationId, payload: resultWithPageInfo}],
    });
  }),

  on(Actions.loadPageFailure, (state, {error, correlationId}) => ({
    ...state,
    isLoading: false,
    error,
    correlationId,
  })),

  on(Actions.setCurrentEntity, (state, {entity}) => ({
    ...state,
    currentEntity: entity,
  })),

  on(Actions.getActiveCheckout, (state,{correlationId}) => ({
    ...state,
    isLoading: true,
    correlationId,
  })),

  on(Actions.setActiveCheckout, (state, {entity}) => ({
    ...state,
    activeCheckout: entity,
  })),

  on(Actions.getActiveCheckoutSuccess, (state, {entity,correlationId}) => {
    if (!correlationId)
      return ({
        ...state,
        isLoading: false,
        activeCheckout: entity,
        error: undefined,
      });

    return ({
      ...state,
      isLoading: false,
      error: undefined,
      activeCheckout: entity,
      correlationId,
      history: [...state.history, {correlationId, payload: entity}]
    });
  }),

  on(Actions.getActiveCheckoutFailure, (state, {error,correlationId}) => ({
    ...state,
    activeCheckout: undefined,
    error,
    isLoading: false,
    correlationId
  })),

  on(Actions.createOrder, (state, { checkout, correlationId }) => ({
    ...state,
    isLoading: true,
    correlationId,
    checkout,
  })),

  on(Actions.createOrderSuccess, (state, {orderResult, correlationId }) => {
    if (!correlationId)
      return {
        ...state,
        isLoading: false,
      };

    return ({
      ...state,
      isLoading: false,
      history: [...state.history, {correlationId, payload: orderResult}],
    });
  }),

  on(Actions.createOrderFailure, (state, { error, correlationId }) => ({
    ...state,
    isLoading: false,
    error: error,
    correlationId,
  })),


  on(Actions.setPaginationSettings, (state, {page}) => ({
    ...state,
    currentPage: {totalCount: state.currentPage?.totalCount, page},
  })),

  on(Actions.setSortSettings, (state, {tableSort}) => ({
    ...state,
    sortSettings: tableSort,
  })),

  on(Actions.setCurrentEntityId, (state, {entityId}) => ({
    ...state,
    currentEntityId: entityId,
  })),

    on(Actions.deselectCurrent, (state, {}) => ({
          ...state,
          currentEntity: undefined,
          currentEntityId: undefined,
        })
    ),

    on(Actions.deselectEntities, (state, {}) => ({
          ...state,
          currentEntities: [],
          currentEntity: undefined,
          currentEntityId: undefined,
        })
    ),
);
